module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/classic-woman-tee/9-8ce464fe6e62ba983b16ce285ae112ce.jpg";